import React from 'react'

export const NothingSelectd = () => {
    return (
        <div className="nothing__main-content">
            <p>
                Select somethng
                <br />
                pr create en entry!
            </p>

            <i className="far fa-star fa-4x mt-5"></i>
            
        </div>
    )
}
